import { useEffect } from "react";
import { useSearchParams } from "react-router";

import { Claim } from "shared/api/claims/api";

import TableDrawer from "pages/Dashboard/components/EventDetails/TableDrawer";
import { LandingPageViewConfig } from "pages/shared/Dashboard/types";

import ClaimDetails from "./ClaimDetails";
import SkeletonLoader from "./SkeletonLoader";

interface Props {
  claim?: Claim;
  onNext: () => void;
  onPrevious: () => void;
  openedIndex: number | null;
  onClose: () => void;
  config: LandingPageViewConfig;
  count: number;
  claimIndex: number;
  smartGroupId?: string;
  isLoading?: boolean;
}

const ClaimDetailsDrawer = ({
  claim,
  config,
  openedIndex,
  onNext,
  onPrevious,
  onClose,
  count,
  claimIndex,
  smartGroupId,
  isLoading,
}: Props) => {
  const [, setSearchParams] = useSearchParams();

  useEffect(() => {
    setSearchParams(
      (prev) => {
        if (openedIndex === null) {
          prev.delete("quickViewIndex");
        } else if (claim) {
          prev.set("quickViewIndex", String(claimIndex));
        }

        return prev;
      },
      { replace: true }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openedIndex, claim?.ID, claimIndex, setSearchParams]);

  if (!claim && isLoading) {
    return (
      <TableDrawer open={openedIndex != null} onClose={onClose}>
        <SkeletonLoader></SkeletonLoader>
      </TableDrawer>
    );
  }

  if (!claim) {
    return null;
  }

  return (
    <TableDrawer open={openedIndex != null} onClose={onClose}>
      <ClaimDetails
        claim={claim}
        onNext={onNext}
        onPrevious={onPrevious}
        config={config}
        count={count}
        claimIndex={claimIndex}
        smartGroupId={smartGroupId}
      />
    </TableDrawer>
  );
};

export default ClaimDetailsDrawer;
